import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import Label from '@/Controls/Label';

export default class MLStringLabelFactory extends ControlFactory {

    private jQueryControl: JQuery;
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    protected Label = ComponentManager.getControl<typeof Label>('Label');

    /**
     * @override
     */
    public viewModel: LabelViewModel;

    private technicalNameRootProperty: string;
    private technicalNameValue: string;

    public constructor(params: any) {
        super(params);
        this.technicalNameRootProperty = '';
        this.technicalNameValue = '';
    }

    /**
     * @override
     */
    control: Label;

    /**
     * @override
     */
    public getControl():JQuery{
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.createViewModel();

        this.control = new this.Label(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.technicalNameValue]);

        return this.jQueryControl;
    }

    private createViewModel(): LabelViewModel {
        this.validateTechName();

        return new this.LabelViewModel({
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            caption: this.context.genericObject.getValue(this.technicalNameValue),
            placeholder: '-'
        });
    }

    private validateTechName(): void {
        this.technicalNameRootProperty = this.detailViewItem.name;
        if (this.detailViewItem.name.substring(this.detailViewItem.name.length - 6) === '.Value') {
            this.technicalNameRootProperty = this.detailViewItem.name.substring(0, this.detailViewItem.name.length - 6);
        }
        this.technicalNameValue = this.technicalNameRootProperty + '.Value';
    }
}

ComponentManager.setFactory('MLStringLabel', MLStringLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');